module.exports = __webpack_public_path__ + "static/media/gosalya-lyadurai.f4043282.jpg";